import React, { memo } from "react";
import { SvgIcon } from "@mui/material";

interface DeviceManagementIconProps {
  className?: string;
  width?: number;
  height?: number;
}

const DeviceManagementIcon: React.FC<DeviceManagementIconProps> = ({
  className,
  width = 24,
  height = 21,
}) => {
  return (
    <SvgIcon
      className={className}
      style={{ width, height }}
      viewBox="0 0 24 21"
      sx={{ fill: "none" }}
    >
      {/* Monitor + stand */}
      <path
        d="M0.671729 0C0.493581 1.95069e-05 0.322734 0.0776081 0.196765 0.215701C0.0707948 0.353795 1.77943e-05 0.541084 0 0.736377V15.4639C1.77943e-05 15.6592 0.0707948 15.8465 0.196765 15.9846C0.322734 16.1227 0.493581 16.2003 0.671729 16.2003H9.40421V17.6745H7.39164C7.36848 17.6732 7.34527 17.6732 7.32211 17.6745C7.14378 17.6846 6.97642 17.7719 6.85684 17.9173C6.73727 18.0627 6.67527 18.2542 6.68449 18.4497C6.69371 18.6452 6.7734 18.8287 6.90601 18.9597C7.03863 19.0908 7.21332 19.1588 7.39164 19.1487H12.7615C12.9399 19.1487 13.1109 19.071 13.237 18.9328C13.3631 18.7946 13.4339 18.6071 13.4339 18.4116C13.4339 18.2161 13.3631 18.0286 13.237 17.8904C13.1109 17.7521 12.9399 17.6745 12.7615 17.6745H10.7477V16.2003H19.4801C19.6583 16.2003 19.8291 16.1227 19.9551 15.9846C20.0811 15.8465 20.1519 15.6592 20.1519 15.4639V0.736377C20.1519 0.541084 20.0811 0.353795 19.9551 0.215701C19.8291 0.0776081 19.6583 1.95069e-05 19.4801 0H0.671729ZM1.34346 1.47275H18.8084V14.7275H1.34346V1.47275Z"
        fill="currentColor"
      />
      {/* Monitor home button dot */}
      <path
        d="M10.7478 13.254C10.7478 13.4493 10.677 13.6365 10.551 13.7746C10.425 13.9127 10.2542 13.9904 10.076 13.9904C9.89787 13.9904 9.72702 13.9127 9.60104 13.7746C9.47507 13.6365 9.4043 13.4493 9.4043 13.254C9.40429 13.1573 9.42167 13.0615 9.45542 12.9722C9.48918 12.8828 9.53866 12.8016 9.60104 12.7332C9.66341 12.6648 9.73746 12.6106 9.81896 12.5736C9.90046 12.5366 9.98781 12.5176 10.076 12.5176C10.1642 12.5176 10.2516 12.5366 10.3331 12.5736C10.4146 12.6106 10.4886 12.6648 10.551 12.7332C10.6134 12.8016 10.6629 12.8828 10.6966 12.9722C10.7304 13.0615 10.7478 13.1573 10.7478 13.254Z"
        fill="currentColor"
      />
      {/* Phone background (white fill to mask monitor behind it) */}
      <path
        d="M18.258 17.4665H18.2659H18.258ZM16.0449 19.9996H20.4712C21.3565 19.9996 21.7992 19.9996 22.1373 19.8155C22.4347 19.6537 22.6766 19.3953 22.8281 19.0775C23.0004 18.7163 23.0004 18.2434 23.0004 17.2976V7.50279C23.0004 6.55701 23.0004 6.0841 22.8281 5.72286C22.6766 5.40509 22.4347 5.14675 22.1373 4.98485C21.7992 4.80078 21.3565 4.80078 20.4712 4.80078H16.0449C15.1596 4.80078 14.7169 4.80078 14.3788 4.98485C14.0813 5.14675 13.8395 5.40509 13.6879 5.72286C13.5156 6.0841 13.5156 6.557 13.5156 7.50279V17.2976C13.5156 18.2434 13.5156 18.7163 13.6879 19.0775C13.8395 19.3953 14.0813 19.6537 14.3788 19.8155C14.7169 19.9996 15.1596 19.9996 16.0449 19.9996Z"
        fill="white"
      />
      {/* Phone outline (stroke) */}
      <path
        d="M18.258 17.4665H18.2659M16.0449 19.9996H20.4712C21.3565 19.9996 21.7992 19.9996 22.1373 19.8155C22.4347 19.6537 22.6766 19.3953 22.8281 19.0775C23.0004 18.7163 23.0004 18.2434 23.0004 17.2976V7.50279C23.0004 6.55701 23.0004 6.0841 22.8281 5.72286C22.6766 5.40509 22.4347 5.14675 22.1373 4.98485C21.7992 4.80078 21.3565 4.80078 20.4712 4.80078H16.0449C15.1596 4.80078 14.7169 4.80078 14.3788 4.98485C14.0813 5.14675 13.8395 5.40509 13.6879 5.72286C13.5156 6.0841 13.5156 6.557 13.5156 7.50279V17.2976C13.5156 18.2434 13.5156 18.7163 13.6879 19.0775C13.8395 19.3953 14.0813 19.6537 14.3788 19.8155C14.7169 19.9996 15.1596 19.9996 16.0449 19.9996Z"
        stroke="currentColor"
        strokeWidth="1.6016"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
};

export default memo(DeviceManagementIcon);
